import { type Theme } from '../types/index.js';

export const baseTheme: Theme = {
  primaryColor: '#5393ff',
  linkColor: '#0440ad',
  infoColor: '#a7d0ff',
  successColor: '#1fd25b',
  warningColor: '#fed719',
  dangerColor: '#ff2800',
  splashColor: '#ffffff',
  themeColor: '#ffffff',
  tileLayer: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
  font: {
    family: 'Open Sans',
    source: 'google',
  },
};
